import React from 'react';
import { Button, Divider, Form, Grid, List, Segment } from 'semantic-ui-react';
import { Field, formValueSelector, reduxForm, reset, change } from 'redux-form';
import { cloneDeep } from 'lodash';

import { connect } from 'react-redux';
import {
  Tech3HiddenInput,
  Tech3InputSearch,
  Tech3Radio,
  Tech3Select
} from '../../../../../../../components/FormElements';
import { email, required } from '../../../../../../../lib/FormValidators';
import {
  getParticipantByEmail,
  setParticipant,
  EMPTY_PARTICIPANT
} from '../../../data/fileImport/participantActions';

import { startSession } from '../../../data/fileImport/sessionsActions';
import { closeAllModals } from '../../../data/fileImport/modalActions';
import { fetchProjectDataTrees } from '../../../data/fileImport/dataTreesActions';

const startSessionFormName = 'startSessionForm';
const startSessionFormSelector = formValueSelector(startSessionFormName);

class StartSessionForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchMsg: ''
    };
    this.props.dispatch(setParticipant(cloneDeep(EMPTY_PARTICIPANT)));

    this.resetValues = this.resetValues.bind(this);
    this.setEmailValue = this.setEmailValue.bind(this);
  }

  componentDidUpdate(prevProps, nextState) {
    if (prevProps.participant.email !== this.props.participant.email) {
      this.setEmailValue(this.props.participant.email);
    }

    return {};
  }

  resetValues() {
    this.setState({
      searchMsg: ''
    });
    this.props.dispatch(setParticipant(cloneDeep(EMPTY_PARTICIPANT)));
    this.props.reset();
  }

  getParticipantStatus() {
    return [
      {
        id: 1,
        label: 'Participant is there',
        value: 'valid'
      },
      {
        id: 2,
        label: 'No show',
        value: 'noShow'
      },
      {
        id: 3,
        label: 'Invalid',
        value: 'invalid'
      },
      {
        id: 4,
        label: 'Exclusion',
        value: 'exclusion'
      },
      {
        id: 5,
        label: 'Refusal',
        value: 'refused'
      }
    ];
  }

  onEmailFieldChange(value) {
    this.setState({
      searchMsg: ''
    });
    this.props.dispatch(setParticipant(cloneDeep(EMPTY_PARTICIPANT)));
  }

  setEmailValue(email) {
    this.props.changeFieldValue('participantEmail', email);
  }

  /**
   * Check participant  email
   * @param {*} email
   *
   */
  searchParticipantByEmail = participantEmail => {
    // rest state
    this.setState({
      dataTreeId: this.props.dataTreeId
    });

    // Email not valid
    if (!this.validateEmail(participantEmail)) {
      this.setState({
        searchMsg: 'Invalid email address'
      });
      this.props.dispatch(setParticipant(cloneDeep(EMPTY_PARTICIPANT)));

      return false;
    }

    // Email valid
    this.props.dispatch(
      getParticipantByEmail(participantEmail, participant => {
        if (!participant.id) {
          // participant not found
          this.setState({
            searchMsg: 'This email is not recognized'
          });
          this.props.dispatch(setParticipant(cloneDeep(EMPTY_PARTICIPANT)));
        } else {
          this.props.dispatch(setParticipant(cloneDeep(participant)));
        }
      })
    );
  };

  /**
   * Validate email
   * @param {*} email
   * @return Bool
   */
  validateEmail(email) {
    return email && /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
  }

  /**
   * Session status list
   */
  listItemsParticipantStatus() {
    return this.getParticipantStatus().map((status, s_i) => (
      <List.Item key={s_i}>
        <Field
          label={status.label}
          name="participantStatus"
          radioValue={status.value}
          idRadio={status.id}
          component={Tech3Radio}
          validate={[required]}
        />
        <span className={`status__color status__color--${status.id}`} />
      </List.Item>
    ));
  }

  /**
   * Submit startSessionForm
   *
   */
  SubmitStartSessionForm(values) {
    const self = this;

    // Check if participant is found
    if (!this.props.participant.id) {
      return false;
    }

    const session = cloneDeep(this.props.session);

    // à ajuster en fonction de l'api
    session.status = values.participantStatus;
    session.condition_id = parseInt(values.condition_id, 10);
    session.participant_id = this.props.participant.id;
    this.props.dispatch(
      startSession(session, () => {
        self.props.dispatch(fetchProjectDataTrees(self.props.project.id));
      })
    );

    // Close modal
    this.props.dispatch(closeAllModals());
    // reset form values
    this.props.dispatch(reset(startSessionFormName));

    this.resetValues();
  }

  render() {
    return (
      <Form
        className="startSessionForm"
        onSubmit={this.props.handleSubmit(this.SubmitStartSessionForm.bind(this))}
      >
        {!this.props.quickParticipantOpened ? (
          <Segment className="startSessionForm__participant-data data-participant-section">
            <h4 className="section-title">Participant Data</h4>
            <Grid columns={16}>
              <Grid.Row>
                <Grid.Column width={9}>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        label="Find user by email in system list"
                        name="participantEmail"
                        type="email"
                        value={this.props.participant.email}
                        onClickSearch={() =>
                          this.searchParticipantByEmail(
                            this.props.startSessionForm.values
                              ? this.props.startSessionForm.values.participantEmail
                              : ''
                          )
                        }
                        component={Tech3InputSearch}
                        validate={[email]}
                        searchMsg={this.state.searchMsg}
                        onChange={() => {
                          this.onEmailFieldChange(
                            this.props.startSessionForm.values
                              ? this.props.startSessionForm.values.participantEmail
                              : ''
                          );
                        }}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <br />
                  <Grid.Row>
                    <Grid.Column>
                      <List className="age-sex">
                        <List.Item className="age">
                          <label>Age</label>
                          <br />
                          <span className="value">{this.props.participant.age}</span>
                        </List.Item>
                        <List.Item className="sex">
                          <label>Sexe</label>
                          <br />
                          <span className="value">{this.props.participant.sex}</span>
                        </List.Item>
                      </List>
                    </Grid.Column>
                  </Grid.Row>
                </Grid.Column>
                <Grid.Column width={7} className="addQuickParticipant">
                  <i
                    className="icon-add-line icon"
                    onClick={() => {
                      this.props.openAddParticipantForm();
                    }}
                  />
                  <h5>Can't find the user ? Add it directly here</h5>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        ) : (
          ''
        )}
        <Segment className="startSessionForm__participant-status">
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <List className="participant-status-list">{this.listItemsParticipantStatus()}</List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>

        <Divider section />

        {this.props.selectedSessionStatus === 'valid' && (
          <Segment className="startSessionForm__participant-condition">
            <h4 className="section-title">Condition</h4>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="condition_id"
                    options={this.props.conditions}
                    placeholder="Choose condition..."
                    component={Tech3Select}
                    upward
                    validate={[required]}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        )}

        <Field name="sessionId" component={Tech3HiddenInput} />
        <div className="submit-btn-container">
          <Button
            className="green right floated"
            disabled={this.props.submitting || !this.props.valid || !this.props.participant.id}
          >
            <i className="check square outline icon" /> OK complete
          </Button>
        </div>
      </Form>
    );
  }
}

const startSessionForm = reduxForm({
  form: startSessionFormName,
  enableReinitialize: true
})(StartSessionForm);

export default connect(
  state => ({
    conditions: state.projects.single.conditions
      ? state.projects.single.conditions.map((condition, i) => {
          return {
            key: condition.id,
            value: condition.id,
            text: condition.name
          };
        })
      : [],
    selectedSessionStatus: startSessionFormSelector(state, 'participantStatus'),
    project: state.projects.single.active,
    startSessionForm: state.form.startSessionForm,
    session: state.projects.single.fileImport.sessions.find(
      session => session.id === state.projects.single.fileImport.modals.startSession.resourceId
    ),
    participant: state.projects.single.fileImport.participant
  }),
  dispatch => {
    return {
      changeFieldValue(field, value) {
        dispatch(change(startSessionFormName, field, value));
      }
    };
  }
)(startSessionForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/StartSessionForm.js